import { createSelector } from '@reduxjs/toolkit';

export const getVenueFeesState = (state) => state.venueFees;

export const getVenueFees = createSelector(getVenueFeesState);
